import React from 'react';
import PropTypes from 'prop-types';
import {Screen} from '../Screen';
import {Input} from './Input';
import {Seperation} from './Seperation';
import {Text} from './Text';
import {useTranslation} from 'react-i18next';

import { composeTime, splitTime } from '../../Timer.utils';

import './style.scss';

const TRANSLATION_KEY = {
  HH: 'HH.string',
  MM: 'MM.string',
  SS: 'SS.string',
  CurrentTime: 'CurrentTime.string',
  HoursInput: 'HoursInput.string',
  MinutesInput: 'MinutesInput.string',
  SecondsInput: 'SecondsInput.string',
};

export function TimerDisplay(props) {

  const {t} = useTranslation();

  const [hours, minutes, seconds] = splitTime(props.time);

  const setTimerSeconds = (seconds) => {
    const [h, m, s] = splitTime(props.time);
    props.setTime(composeTime(h, m, seconds));
  };
  const setTimerMinutes = (minutes) => {
    const [h, m, s] = splitTime(props.time);
    props.setTime(composeTime(h, minutes, s));
  };
  const setTimerHours = (hours) => {
    const [h, m, s] = splitTime(props.time);
    props.setTime(composeTime(hours, m, s));
  };

  return (
    <Screen className='timer_settings_timerDisplay' ariaLabel={t(TRANSLATION_KEY.CurrentTime, {hours: hours, minutes: minutes, seconds: seconds})}>
      <div className='timer_settings_timerDisplay_inputBlock'>
        <Text className='hhText'> {t(TRANSLATION_KEY.HH)} </Text>
        <Input
          className='timer_settings_timerDisplay_inputBlock_input  hh_input'
          value={hours}
          setValue={setTimerHours}
          ariaLabel={t(TRANSLATION_KEY.HoursInput, {hours: hours})}
        />
        <Seperation className='hh_mm_seperator' />
        <Text className='mmText'> {t(TRANSLATION_KEY.MM)}</Text>
        <Input
          className='timer_settings_timerDisplay_inputBlock_input  mm_input'
          value={minutes}
          setValue={setTimerMinutes}
          ariaLabel={t(TRANSLATION_KEY.MinutesInput, {minutes: minutes})}
        />
        <Seperation className='mm_ss_seperator' />
        <Text className='ssText'> {t(TRANSLATION_KEY.SS)}</Text>
        <Input
          className='timer_settings_timerDisplay_inputBlock_input  ss_input'
          value={seconds}
          setValue={setTimerSeconds}
          ariaLabel={t(TRANSLATION_KEY.SecondsInput, {seconds: seconds})}
        />
      </div>
    </Screen>
  );
}

Screen.propTypes = {
  /**
   * date time data for timer
   */
  timeData: PropTypes.instanceOf(Date),
  /**
   * callback function to set time value
   */
  setTime: PropTypes.func,
};

Screen.defaultProps = {
  className: '',
};
